import { universalParallax } from '../lib/universal-parallax/dist/universal-parallax.js';

$(document).ready(function () {

    var parallaxArray = document.getElementsByClassName("parallaxblockmodel");

   if (parallaxArray.length > 0) {
      new universalParallax().init({speed: 6.0});
   }
});